import _ from 'lodash';

import moment from 'moment';

import React from 'react'

import { AppConstant } from '../../../../../../../Assests/AppConstant';



const RecommendedTimeslotSS = (props) => {

    const { selectedDate, ssRecommendationsArr, loading, errorMsg, handleTimeSlotClick, timeSlot } = props;

  const hasStandingSlots = _.size(ssRecommendationsArr) &&
    ssRecommendationsArr.some(el => el?.RecommendationType === 'STANDING');

    const hasRescheduleSlots = _.size(ssRecommendationsArr) &&
        ssRecommendationsArr.some(el => el?.RecommendationType === 'RESCHEDULE');

    const renderSlotBadge = (el) => {
        if (el?.RecommendationType === 'STANDING') {
  return (
       <span className='standing-badge'>
        <i className='fa-solid fa-thumbtack me-1' style={{ fontSize: '8px' }}></i>
          Fixed
          </span>
   );
   }
    return null;
    };

    const getSlotClassName = (el) => {
        const isSelected =
            timeSlot?.TimeSlotName === el?.TimeSlotName &&
            timeSlot?.ApptStartTime === el?.ApptStartTime;

 if (el?.RecommendationType === 'STANDING') {
            return isSelected ? 'time-slot-ss-standing-selected' : 'time-slot-ss-standing';
        }
    if (el?.RecommendationType === 'RESCHEDULE') {
            return isSelected ? 'time-slot-ss-reschedule-selected' : 'time-slot-ss-reschedule';
        }
return isSelected ? 'time-slot-ss-selected' : 'time-slot-ss';
    };

    return (
        <>
  <div className='d-flex flex-column align-items-center justify-content-between px-2 pt-1'>
                <p className='p-2 mb-0'>
          {selectedDate
  ? `${moment(selectedDate).tz(moment.tz.guess()).format('MMM')}, ${moment(selectedDate).tz(moment.tz.guess()).format('DD')}`
       : '--'}
          </p>
     {hasStandingSlots ? (
  <span className='standing-legend-pill'>
  <i className='fa-solid fa-thumbtack me-1' style={{ fontSize: '9px' }}></i>
            Fixed slots available
     </span>
    ) : ''}
         {hasRescheduleSlots ? (
          <span className='reschedule-legend-pill'>
                <i className='fa-solid fa-rotate-left me-1' style={{ fontSize: '9px' }}></i>
           Includes your last booked time
                 </span>
          ) : ''}
   </div>

      <div className='d-flex justify-content-between flex-column gap-2 p-2 slots-wrapper'>
 {
    _.size(ssRecommendationsArr) ? ssRecommendationsArr.map((el, idx) => {

 const isStanding = el?.RecommendationType === 'STANDING';
          const isReschedule = el?.RecommendationType === 'RESCHEDULE';

            return (
         <div
 key={idx}
        className={`slot-item-wrapper ${isStanding ? 'standing-slot-wrapper' : ''} ${isReschedule ? 'reschedule-slot-wrapper' : ''}`}
    title={
       isStanding
    ? 'This is a fixed/standing slot pre-assigned for this dock.'
: isReschedule
      ? 'This is the same timeslot as your last scheduled appointment.'
 : ''
    }
           onClick={(e) => handleTimeSlotClick(e, el)}
          >
   {/* {isReschedule && (
                  <div className='reschedule-corner-ribbon'>
      <i className='fa-solid fa-rotate-left'></i>
          </div>
        )} */}

       <div className={getSlotClassName(el)}>
        <span className='slot-time-label'>
      {el.ApptStartTime
    ? moment(el.ApptStartTime).utc().format(AppConstant.commonStrings.hh_mm_A_dateFormat)
            : '-'}
</span>
        {renderSlotBadge(el)}
    {isReschedule && (
   <span className='reschedule-inline-badge'>
          <i className='fa-solid fa-rotate-left me-1' style={{ fontSize: '7px' }}></i>
            Last
      </span>
              )}
              </div>

        {isStanding && (
      <p className='standing-slot-disclaimer'>
            <i className='fa-solid fa-circle-info me-1'></i>
          Pre-assigned fixed slot
           </p>
       )}

  {isReschedule && (
    <div className='reschedule-history-bar'>
         <div className='reschedule-history-bar-icon'>
  <i className='fa-solid fa-clock-rotate-left'></i>
     </div>
           <span className='reschedule-history-bar-text'>
        Your last scheduled time
    </span>
       </div>
          )}
                    </div>
        );

           }) : 'No data Found'
      }
        </div>
 </>
    );

}



export default RecommendedTimeslotSS;